import useUrl from "hooks/useUrl"
import React, { useMemo } from "react"
import { Image, Loading, Swipe } from "react-vant"

function ProductDetailMatImg(
  {
    mainImage,
    imgPaths = [],
    imgTag,
  }: {
    mainImage: SkuDetail.PageMallSkuDetail["mainImage"]
    imgPaths: SkuDetail.PageMallSkuDetail["imgPaths"]
    imgTag: SkuDetail.PageMallSkuDetail["imageProductTag"]
  },
  ref,
) {
  const { getPublicUrl } = useUrl()
  const carouselChildren = useMemo(
    () =>
      imgPaths.map((url, idx) => (
        <Swipe.Item key={idx}>
          <div className="matImg">
            <Image
              src={getPublicUrl(url)}
              alt=""
              fit="contain"
              loadingIcon={<Loading type="spinner" />}
            />
            {imgTag?.[0] && (
              <span className="img-tag">{imgTag?.[0].tagName}</span>
            )}
          </div>
        </Swipe.Item>
      )),
    [imgPaths],
  )

  return (
    <>
      <div className="matImgWrapper">
        <div className="flyerWrapper">
          <img
            src={getPublicUrl(mainImage!)}
            className="flyer"
            alt=""
            ref={ref}
          />
        </div>
        {imgPaths && imgPaths.length > 0 && (
          <Swipe
            pagination={{
              renderFraction: (currentClass, totalClass) => {
                return (
                  `<div class="pager"><span class="${currentClass}"></span>` +
                  `/` +
                  `<span class="${totalClass}"></span></div>`
                )
              },
              type: "fraction",
            }}
          >
            {carouselChildren}
          </Swipe>
        )}
      </div>
      <style jsx>{`
        .matImgWrapper {
          position: relative;
          height: 375px;
        }

        .matImgWrapper :global(.matImg) {
          height: 375px;
          background: #fff;
          text-align: center;
        }

        .matImgWrapper :global(.matImg img) {
          height: 100%;
          max-width: 100%;
        }
        .flyerWrapper {
          position: fixed;
          text-align: center;
          width: 100vw;
          top: 100px;
        }

        .flyer {
          visibility: hidden;
          width: 40px;
          height: 40px;
          border-radius: 100%;
          background-color: #1156ff;
        }

        .flyer img {
          width: 50px;
          height: 50px;
          border-radius: 100%;
          box-shadow: 0 2px 12px 0 rgb(31 82 249 / 25%);
        }

        .matImgWrapper :global(.pager) {
          position: absolute;
          bottom: 10px;
          right: 16px;
          background: rgba(46, 45, 55, 0.7);
          border-radius: 31.5px;
          font-size: 12px;
          color: #ffffff;
          text-align: justify;
          width: 43px;
          height: 22px;
          line-height: 22px;
          text-align: center;
        }
        .matImgWrapper :global(.img-tag) {
          position: absolute;
          left: 10px;
          top: 10px;
          z-index: 1;
          padding: 1px 6px;
          background-color: #f5222d;
          color: #fff;
          font-size: 12px;
          border-radius: 1px;
        }
      `}</style>
    </>
  )
}

export default React.forwardRef(ProductDetailMatImg)
